import {
  CommendaAiFeedbackCategory,
  CommendaAiFeedbackRating,
} from '@commenda/api/commenda-ai/types';

interface CommendaAiFeedbackCategoryOption {
  value: CommendaAiFeedbackCategory;
  label: string;
}

export class CommendaAiMessageFeedbackHelper {
  static readonly DEFAULT_POSITIVE_CATEGORY: CommendaAiFeedbackCategory =
    CommendaAiFeedbackCategory.GOOD_RESPONSE;

  static readonly POSITIVE_FEEDBACK_CATEGORY_OPTIONS: readonly CommendaAiFeedbackCategoryOption[] =
    [
      {
        value: CommendaAiFeedbackCategory.GOOD_RESPONSE,
        label: 'Good response',
      },
      {
        value: CommendaAiFeedbackCategory.SAVED_ME_TIME,
        label: 'Saved me time',
      },
      {
        value: CommendaAiFeedbackCategory.CAUGHT_SOMETHING_I_MISSED,
        label: 'Caught something I missed',
      },
      {
        value: CommendaAiFeedbackCategory.WELL_PRESENTED,
        label: 'Well presented',
      },
      {
        value: CommendaAiFeedbackCategory.SOMETHING_ELSE,
        label: 'Something else',
      },
    ];

  static readonly NEGATIVE_FEEDBACK_CATEGORY_OPTIONS: readonly CommendaAiFeedbackCategoryOption[] =
    [
      {
        value: CommendaAiFeedbackCategory.WRONG_INFORMATION,
        label: 'Wrong information',
      },
      {
        value: CommendaAiFeedbackCategory.WRONG_ENTITY_OR_COMPANY,
        label: 'Used the wrong entity or company',
      },
      {
        value: CommendaAiFeedbackCategory.MISSING_CAPABILITY,
        label: "Couldn't do it, no tool for this",
      },
      {
        value: CommendaAiFeedbackCategory.INCORRECT_REFUSAL,
        label: 'Refused something it should have done',
      },
      {
        value: CommendaAiFeedbackCategory.ACTED_WITHOUT_CONFIRMING,
        label: 'Acted without confirming first',
      },
      {
        value: CommendaAiFeedbackCategory.INCOMPLETE_ANSWER,
        label: 'Incomplete answer',
      },
      {
        value: CommendaAiFeedbackCategory.FORMATTING_OR_PRESENTATION,
        label: 'Formatting or presentation',
      },
      {
        value: CommendaAiFeedbackCategory.SOMETHING_ELSE,
        label: 'Something else',
      },
    ];

  static getFeedbackCategoryOptions(
    rating: CommendaAiFeedbackRating
  ): readonly CommendaAiFeedbackCategoryOption[] {
    return rating === CommendaAiFeedbackRating.UP
      ? CommendaAiMessageFeedbackHelper.POSITIVE_FEEDBACK_CATEGORY_OPTIONS
      : CommendaAiMessageFeedbackHelper.NEGATIVE_FEEDBACK_CATEGORY_OPTIONS;
  }
}
